import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Public\UserController::at
* @see app/Http/Controllers/Public/UserController.php:21
* @route 'https://mktcode.digital/@{user}'
*/
export const at = (args: { user: string | number | { username: string | number } } | [user: string | number | { username: string | number } ] | string | number | { username: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: at.url(args, options),
    method: 'get',
})

at.definition = {
    methods: ["get","head"],
    url: 'https://mktcode.digital/@{user}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\UserController::at
* @see app/Http/Controllers/Public/UserController.php:21
* @route 'https://mktcode.digital/@{user}'
*/
at.url = (args: { user: string | number | { username: string | number } } | [user: string | number | { username: string | number } ] | string | number | { username: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'username' in args) {
        args = { user: args.username }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.username
        : args.user,
    }

    return at.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\UserController::at
* @see app/Http/Controllers/Public/UserController.php:21
* @route 'https://mktcode.digital/@{user}'
*/
at.get = (args: { user: string | number | { username: string | number } } | [user: string | number | { username: string | number } ] | string | number | { username: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: at.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\UserController::at
* @see app/Http/Controllers/Public/UserController.php:21
* @route 'https://mktcode.digital/@{user}'
*/
at.head = (args: { user: string | number | { username: string | number } } | [user: string | number | { username: string | number } ] | string | number | { username: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: at.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\UserController::at
* @see app/Http/Controllers/Public/UserController.php:21
* @route 'https://mktcode.digital/@{user}'
*/
const atForm = (args: { user: string | number | { username: string | number } } | [user: string | number | { username: string | number } ] | string | number | { username: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: at.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\UserController::at
* @see app/Http/Controllers/Public/UserController.php:21
* @route 'https://mktcode.digital/@{user}'
*/
atForm.get = (args: { user: string | number | { username: string | number } } | [user: string | number | { username: string | number } ] | string | number | { username: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: at.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\UserController::at
* @see app/Http/Controllers/Public/UserController.php:21
* @route 'https://mktcode.digital/@{user}'
*/
atForm.head = (args: { user: string | number | { username: string | number } } | [user: string | number | { username: string | number } ] | string | number | { username: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: at.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

at.form = atForm

const show = {
    at: Object.assign(at, at),
}

export default show